module.exports = __webpack_public_path__ + "static/ARCHICOM-PNG-d90edc18d4a3c1ef7c770bf987fdb267.png";